"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkout = exports.addMessageEventListener = void 0;
const config_1 = require("./services/config");
const MODAL_ID = 'commercetools-checkout';
const CONTAINER_EMBEDDED = 'data-ctc';
let listener;
const IFRAME_STYLES = 'display: none; top: 0; position: fixed; height: 100%; width: 100%; z-index: 100000;';
const originalOverflow = document.body.style.overflow;
const getEmbeddedContainer = () => {
    const embeddedAll = document.querySelectorAll(`[${CONTAINER_EMBEDDED}]`);
    if (embeddedAll.length > 0 &&
        (embeddedAll[0] instanceof HTMLDivElement || embeddedAll[0] instanceof HTMLSpanElement))
        return embeddedAll[0];
    return null;
};
var PostMessageCodes;
(function (PostMessageCodes) {
    PostMessageCodes["InitCheckout"] = "init_checkout";
})(PostMessageCodes || (PostMessageCodes = {}));
const closeModal = () => {
    const modal = document.getElementById(MODAL_ID);
    if (modal) {
        document.body.style.overflow = originalOverflow;
        modal.remove();
    }
    const embedded = getEmbeddedContainer();
    if (embedded) {
        embedded.innerHTML = '';
    }
    if (listener) {
        window.removeEventListener('message', listener);
    }
};
const addMessageEventListener = (iframe) => {
    listener = ({ origin, data }) => {
        var _a;
        if (origin !== (0, config_1.getInterlocutor)())
            return;
        if ((data === null || data === void 0 ? void 0 : data.code) === 'checkout_cancelled') {
            closeModal();
        }
        if ((data === null || data === void 0 ? void 0 : data.code) === 'checkout_loaded') {
            const checkoutConfig = Object.assign({}, (0, config_1.getCheckoutConfig)());
            delete checkoutConfig.callbackUrl;
            const dest = iframe ? iframe.contentWindow : window;
            dest.postMessage({ code: PostMessageCodes.InitCheckout, payload: checkoutConfig }, (0, config_1.getInterlocutor)());
        }
        if ((data === null || data === void 0 ? void 0 : data.code) === 'checkout_completed') {
            closeModal();
            const { id } = ((_a = data === null || data === void 0 ? void 0 : data.payload) === null || _a === void 0 ? void 0 : _a.order) || {};
            const { callbackUrl } = (0, config_1.getCheckoutConfig)();
            if (callbackUrl) {
                window.location.href = `${callbackUrl}?orderId=${id}`;
            }
        }
    };
    window.addEventListener('message', listener);
};
exports.addMessageEventListener = addMessageEventListener;
const createModalIframe = () => {
    // create the iframe and append to the document body
    const iframe = document.createElement('iframe');
    (0, exports.addMessageEventListener)(iframe);
    iframe.src = (0, config_1.getAppHost)();
    iframe.title = 'Checkout';
    iframe.setAttribute('id', MODAL_ID);
    iframe.setAttribute('style', IFRAME_STYLES);
    iframe.onload = () => {
        // scroll to the iframe
        iframe.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    document.body.appendChild(iframe);
    document.body.style.overflow = 'hidden';
    return iframe;
};
const createModal = async () => {
    closeModal();
    (0, exports.addMessageEventListener)();
    if (!getEmbeddedContainer()) {
        const div = document.createElement('div');
        div.setAttribute('id', MODAL_ID);
        document.body.appendChild(div);
        document.body.style.overflow = 'hidden';
    }
    if (typeof window.commercetoolsCheckout === 'object' &&
        typeof window.commercetoolsCheckout.render === 'function') {
        window.commercetoolsCheckout.render();
    }
    else {
        const script = document.createElement('script');
        script.src = `${(0, config_1.getAppHost)()}/main.js`;
        document.head.appendChild(script);
    }
};
const checkout = (checkoutData) => {
    (0, config_1.updateCheckoutConfig)(checkoutData);
    if ((0, config_1.getIsIframe)()) {
        const modal = document.getElementById(MODAL_ID) || createModalIframe();
        modal.style.display = 'block';
    }
    else {
        createModal();
    }
};
exports.checkout = checkout;
//# sourceMappingURL=checkout.js.map